import api from 'api'
import type {
  Category,
  VerificationType,
} from 'api/company/position/requirement/types'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

type FuzzySearchRequirement = {
  id: number
  name: string
  category: Category
  verificationType: VerificationType
}

export const getRequirementsByFuzzySearch = async ({
  search,
  limit = 100,
}: {
  search: string
  limit?: number
}): Promise<FuzzySearchRequirement[]> => {
  const result = await api.get('/admin/requirement/fuzzy_search', {
    params: {
      search: search.trim(),
      limit,
    },
    paramsSerializer: queryParamSerializer,
  })

  return result.data.items
}
